//   This files handles the parsing of the categories being followed

export function parseAdPlatforms(adPlatforms) {
  return adPlatforms;
}
